import 'components/filter_form/desktop_toggle';
import 'components/filter_form/toggle';
import 'components/filter_form/header';
import 'components/filter_form/footer';
import QueryString from 'utils/query_string';
import omit from 'lodash/omit';

import 'styles/components/_input-groups.scss';
import './index.scss';

class FilterForm {
  constructor($form) {
    jQuery.event.special.filterFormToggle = {
      noBubble: false
    };

    this.$form = $form;
    this.$toggle = $('.js-filter-form-toggle');
    this.bindAll();
  }

  bindAll() {
    this.bindFilterFormActions();
    this.bindFilterFormActionButtons();
    this.bindFilterFormToggle();
    this.bindFilterFormToggleButton();
  }

  bindFilterFormActions() {
    this.$form.on('change', 'input:not([data-no-summary])', () => this.toggleFilterFormActionButtons());
    EventManager.subscribe('autofillByQueryString.applied', () => this.toggleFilterFormActionButtons());
    $(document).on('filterFormToggle', () => this.toggleFilterFormToggle());
  }

  bindFilterFormActionButtons() {
    this.toggleFilterFormActionButtons();

    $('.js-btn-clean', this.$form).on('click', () => {
      this.$form.clearForm();
      return false;
    });
  }

  bindFilterFormToggle() {
    this.$toggle.on('change', () => {
      const checked = this.$toggle.is(':checked');

      if (checked)
        $('body').addClass('q-no-scroll');
      else
        $('body').removeClass('q-no-scroll');
    });
  }

  bindFilterFormToggleButton() {
    const $toggleButton = $('.js-filter-form-toggle-btn');

    if($toggleButton.length) {
      const text = this.areFiltersApplied() ?
        $toggleButton.data().activeText :
        $toggleButton.data().inactiveText;

      $toggleButton.find('span').html(text);
    }
  }

  areFiltersApplied() {
    const params = QueryString.getQueryStringData();
    const isFormNotEmpty = !!Object.keys(omit(this.$form.serializeObject(), ['per_page'])).length;
    const hasQueryParams = !!Object.keys(omit(params, ['sort', 'per_page'])).length;

    return !!(isFormNotEmpty || hasQueryParams);
  }

  toggleFilterFormActionButtons() {
    $('.js-filter-form-actions button', this.$form)
      .not('.js-always-display')
      .each((i, button) => $(button).attr('disabled', !this.areFiltersApplied()));

    this.$form.find('.js-filter-button').attr('disabled', !this.areFiltersApplied());
  }

  toggleFilterFormToggle() {
    if (MediaQuery.is('md')) return;

    this.$toggle
      .prop('checked', !this.$toggle.prop('checked'))
      .trigger('change');
  }
}

(function ($) {
  'use strict';

  if (!$.fn.filterForm) {
    $.fn.filterForm = function () {
      const $form = $(this);
      this.filterFormInstance = new FilterForm($form);
      return $form;
    };
  }
})(jQuery);
